export class ProductState {
  private stateKey: string;
  private name: string;
  private uf: string;
  private ufCode: number;
  private districts: Array<any>;

  public getStateKey(): string {
    return this.stateKey;
  }

  public setStateKey(stateKey: string): void {
    this.stateKey = stateKey;
  }

  public getName(): string {
    return this.name;
  }

  public setName(name: string): void {
    this.name = name;
  }

  public getUf(): string {
    return this.uf;
  }

  public setUf(uf: string): void {
    this.uf = uf;
  }

  public getUfCode(): number {
    return this.ufCode;
  }

  public setUfCode(ufCode: number): void {
    this.ufCode = ufCode;
  }

  public getDistricts(): Array<any> {
    return this.districts;
  }

  public setDistricts(districts: Array<any>): void {
    this.districts = districts;
  }
}
